export const commands = [
  { title: 'Home', icon: 'dashboard', route: 'home' },
  { title: 'About', icon: 'question_answer', route: 'about' },
  { 
    title: 'Commands', 
    icon: 'subject',
    route: 'commands',
    commands: [
      { 
        title: 'animes',
        commands: [
          { 
            title: 'anime',
            info: `Search animes/mangas by titles.`,
            usage: `<prefix>a [anime or manga] [title]`,
            description: `You can <prefix>anime guilty crown`
          }
        ]
      },
      {
        title: 'azurlane',
        commands: [
          { 
            title: 'azur',
            info: 'Find botes.',
            usage: '<prefix>azurlane name',
            description: 'You can use <prefix>azur hammann and u get best bote ~~hen~tai!!'
          },
          { 
            title: 'azurt',
            info: 'Show last twitter from azurlane.',
            usage: '<prefix>azurt',
            description: `<br>You can use lang jp to show twitter jp, Examples: <br>` +
            `<prefix>azurt <-- show eng twitter<br>` +
            `<prefix>azurt jp <-- show jp twitter<br>` +
            `more info use <prefix>h azurt`
          }
        ]
      },
      {
        title: 'games',
        commands: [
          { 
            title: 'slots',
            info: 'Play game slot',
            usage: '<prefix>slot',
            description: ''
          }
        ]
      },
      {
        title: 'granblue',
        commands: [
          { 
            title: 'gbf',
            info: 'Wiki GBF',
            usage: '<prefix>gbf [options]',
            description: `<br>Examples: <br>` +
            `<prefix>gbf events <-- show next events<br>` +
            `<prefix>gbf char Yuel <-- show character info + link wiki<br>` +
            `<prefix>gbf summon Shiva <-- show summon info + link wiki<br>` +
            `<prefix>gbft <-- show last twitter from gbf, use flag --jp to show twitter jp, more info use <prefix>h gbft`
          },
          { 
            title: 'gbft',
            info: 'Show last twitter from granblue fantasy.',
            usage: '<prefix>gbft',
            description: `<br>Examples: <br>` +
            `<prefix>gbft <-- show eng twitter<br>` +
            `<prefix>gbft jp <-- show jp twitter`
          }
        ]
      },
      {
        title: 'info',
        commands: [
          { 
            title: 'commands',
            info: 'Commands List',
            usage: '<prefix>commands',
            description: 'Lista all commands or by group using: <prefix>commands gbf or azurlane'
          },
          { 
            title: 'help',
            info: 'Help Command',
            usage: '<prefix>help command_name',
            description: 'You get all infos about command.'
          },
          { 
            title: 'wiki',
            info: 'Wiki Hammann',
            usage: '<prefix>wiki',
            description: 'You get link.'
          }
        ]
      },
      {
        title: 'others',
        commands: [
          { 
            title: 'choose',
            info: 'Makes a choice for you. max 5',
            usage: '<prefix>choose option1, option2',
            description: 'You want roll or dont roll? <prefix>choose roll, dont roll'
          },
          { 
            title: 'gender',
            info: 'Determines the gender of a name.',
            usage: '<prefix>gender [name]',
            description: 'Some times u need know if Yuel is Male or Female name lol'
          },
          { 
            title: 'say',
            info: 'Say something..',
            usage: '<prefix>say something',
            description: ''
          }
        ]
      },
      {
        title: 'patreon',
        commands: [
          { 
            title: 'patreon',
            info: 'Help to pay server XD',
            usage: '<prefix>patreon',
            description: 'Show link patreon'
          }
        ]
      },
      {
        title: 'reminders',
        commands: [
          { 
            title: 'addreminder',
            info: 'Adds a reminder that triggers at the given time and tells you.',
            usage: '<prefix>addreminder [1day or 16hours] [group or pm] [command or message] [command [options] or message]',
            description: `<br>example:` +
            `<br><prefix>addre 10h group message today was in one event of botes lewd. or ` +
            `<br><prefix>addre 5h group command azurlane hammann ` +
            `<br>You can add last argument --every to repeat every day same time. <br>Minimum time is 5m`
          },
          { 
            title: 'reminders',
            info: 'List all your reminders.',
            usage: '<prefix>relist',
            description: 'List all your reminders and show infos about.'
          },
          { 
            title: 'deletereminder',
            info: 'Delete your reminder.',
            usage: '<prefix>delre [number]',
            description: 'When you list your reminder give number by id, just use thats id to delete'
          }
        ]
      },
      {
        title: 'stickers',
        commands: [
          { 
            title: 'emo',
            info: 'Send stickers/emoji',
            usage: '<prefix>emo code_sticker',
            description: ''
          },
          { 
            title: 'sticker',
            info: 'Custom sticker/emo.',
            usage: '<prefix>s [get, set, remove] [sticker] [url-link-image]',
            description: `You can easy add emo now, ` +
            `Image size are fine 500x500 or 1040x1040, ` +
            `you cant add gifs image, after added u uses: <prefix>s [sticker], ` +
            `<br>examples: ` +
            `<br>add: <prefix>s set hammann [url-link-image] ` +
            `<br>list: <prefix>s ` +
            `<br>usage: <prefix>s hammann ` +
            `<br>remove: <prefix>s remove hammann`
          },
          { 
            title: 'stickers',
            info: 'List all stickers',
            usage: '<prefix>stickers',
            description: 'you can use <prefix>stickers [category] to list only that [category].'
          }
        ]
      },
      {
        title: 'utils',
        commands: [
          { 
            title: 'setlang',
            info: 'List languages or set language',
            usage: '<prefix>lang [lang]',
            description: 'Hammann have languages English, Japanese'
          },
          { 
            title: 'name',
            info: 'Add a group name for Hammann to know when to interact in commands',
            usage: '<prefix>name [name]',
            description: 'Hammann can save name for your group and use it later for news commands.'
          },
          { 
            title: 'prefix',
            info: 'Show current prefix or replace it',
            usage: '<prefix>prefix [new prefix]',
            description: 'You can set custom prefix for your group.'
          },
          { 
            title: 'replace',
            info: 'Replace text',
            usage: '<prefix>replace [it] [to] [text]',
            description: 'Your can replace some texts: <br><prefix>replace warspite hammann best bote is warspite <br>result: best bote is hammann'
          },
          { 
            title: 'reverse',
            info: 'Reverse text.',
            usage: '<prefix>reverse [text]',
            description: ''
          },
          { 
            title: 'tags',
            info: 'Short some text or create tags',
            usage: '<prefix>tags [get, set, remove] [tag] [text]',
            description: `<br>Example: <prefix>tag set wiki link-of-azurlane ` +
            `<br><prefix>tag wiki ` +
            `<br>result: link-of-azurlane`
          }
        ]
      },
      {
        title: 'web',
        commands: [
          { 
            title: 'danbooru',
            info: 'Search image with tags in danbooru',
            usage: '<prefix>danbooru tags',
            description: ''
          },
          { 
            title: 'gelbooru',
            info: 'Search image with tags in gelbooru',
            usage: '<prefix>gelbooru tags',
            description: ''
          },
          { 
            title: 'konachan',
            info: 'Search image with tags in konachan',
            usage: '<prefix>konachan tags',
            description: ''
          },
          { 
            title: 'saucenao',
            info: 'Find sauces.',
            usage: '<prefix>sauce [url-image]',
            description: ''
          },
          { 
            title: 'youtube',
            info: 'Find videos.',
            usage: '<prefix>youtube title',
            description: ''
          }
        ]
      }
    ] 
  },
  { title: 'Stickers', icon: 'insert_emoticon', route: 'stickers' }
]
